import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { Batu } from '../../batu/interface/Batu';

export const setBatuAction = (batu: Batu) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.SET_BATU, payload: batu });
  };
};

export const resetBatu = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.RESET_BATU });
  };
};
